export default __webpack_public_path__ + "c37b6bd6fc62f3aef3edb56bc71a3c90.png";